<template>
  <div>
    <label>Integrations:</label>
    <el-select
      v-model="addStatsData.integrationsSettings.integration_id"
      style="width: 100%"
      @change="resetFormAndUpdateEvents"
    >
      <el-option
        v-for="integrate in allIntegrations"
        :key="integrate._id"
        :label="integrate.name"
        :value="integrate._id"
      ></el-option>
    </el-select>
    <label style="display: block; margin-bottom: 10px">Event:</label>
    <el-select
      v-model="addStatsData.integrationsSettings.event_id"
      placeholder="Select event"
      style="width: 100%"
      :clearable="true"
      @change="setAsset"
    >
      <el-option
        v-for="(option, index) in selectedApplicationEvents"
        :key="index"
        :label="option.eventName.replaceAll('_', ' ')"
        :value="option._id"
      />
    </el-select>
    <div>
      <el-checkbox
        v-if="
          addStatsData.integrationsSettings.event &&
          addStatsData.integrationsSettings.event.settings
            .isDateFilterIncluded &&
          addStatsData.display_type !== 'FORMULA'
        "
        v-model="addStatsData.apply_date_filter"
        style="width: 100%; margin-top: 10px"
        disabled
        >Apply date filter</el-checkbox
      >
    </div>
    <div
      v-for="field in addStatsData.integrationsSettings.event?.settings
        .requiredFields"
      :key="field.key"
    >
      <label style="display: block; margin-bottom: 10px">{{
        field.label
      }}</label>
      <div v-if="field.type == 'select'">
        <el-select
          v-model="addStatsData.integrationsSettings.dependencies[field.key]"
          :placeholder="field.placeholder ? field.placeholder : 'select any'"
          style="width: 100%"
          :clearable="true"
          filterable
          @change="loadDependentFields(field)"
        >
          <el-option
            v-for="option in field.values"
            :key="option.id"
            :label="option.name"
            :value="option.id"
          />
          <el-button
            v-if="field.values.length >= fieldPagination[field.key]?.limit"
            :loading="fieldPagination[field.key]?.loading"
            @click="loadDependentFields(field)"
            type="text"
            style="margin-left: 1rem"
          >
            Load More...
          </el-button>
        </el-select>
      </div>
    </div>
    <br />
    <div>
      <el-radio
        v-model="addStatsData.integrationsSettings.radioFilter"
        label="1"
        >Exisisting Global Filters</el-radio
      >
      <el-radio
        v-model="addStatsData.integrationsSettings.radioFilter"
        label="2"
        >Add New Global Filters</el-radio
      >
    </div>
    <br />
    <div v-if="addStatsData.integrationsSettings.event">
      <div v-if="addStatsData.integrationsSettings.radioFilter === '1'">
        <el-select
          v-model="addStatsData.integrationsSettings.exisitingFilterComponent"
          placeholder="select Exisisting global filters from component"
          style="width: 100%"
          :clearable="true"
        >
          <el-option
            v-for="(option, index) in getGlobalFilterComponents"
            :key="index"
            :label="option.component_name"
            :value="option.keyValue"
          />
        </el-select>
      </div>

      <div v-else>
        <el-select
          v-model="addStatsData.integrationsSettings.globalFilters"
          placeholder="select global filters from here"
          style="width: 100%"
          :clearable="true"
          multiple
        >
          <el-option
            v-for="(option, index) in addStatsData.integrationsSettings.event
              .settings.requiredFields"
            :key="index"
            :label="option.label"
            :value="option.key"
          />
        </el-select>
      </div>
    </div>
    <div
      v-if="
        this.addStatsData.integrationsSettings.event &&
        this.addStatsData.integrationsSettings.event.settings.supportType !=
          'stat' &&
        this.addStatsData.integrationsSettings.event.settings.availableColumns
      "
    >
      <label style="display: block; margin-bottom: 10px">Dimension:</label>
      <el-select
        v-model="addStatsData.integrationsSettings.groupBy"
        placeholder="Select Fields"
        style="width: 100%"
        :clearable="true"
      >
        <el-option
          v-for="(field, index) in this.addStatsData.integrationsSettings.event
            .settings.dimensions"
          :key="index"
          :label="field.label"
          :value="field.key"
        />
      </el-select>
      <label style="display: block; margin-bottom: 10px">Fields:</label>
      <el-select
        v-model="addStatsData.integrationsSettings.selectedFields"
        placeholder="Select Fields"
        style="width: 100%"
        :clearable="true"
        multiple
      >
        <el-option
          v-for="(field, index) in this.addStatsData.integrationsSettings.event
            .settings.availableColumns"
          :key="index"
          :label="field.label"
          :value="field.key"
        />
      </el-select>
      <label style="display: block; margin-bottom: 10px">Limit:</label>
      <el-select
        v-model="addStatsData.integrationsSettings.limit"
        placeholder="Select Limit"
        style="width: 100%"
        :clearable="true"
        default-first-option
      >
        <el-option
          v-for="(value, index) in limitOptions"
          :key="index"
          :label="value"
          :value="value"
        />
      </el-select>
    </div>
  </div>
</template>
<script>
import { postAPICall } from "@/helpers/httpHelper";
export default {
  props: {
    addStatsData: Object,
    integrations: Array,
    customDashboardData: Object,
  },
  data() {
    return {
      selectedApplicationEvents: [],
      sanitizedEvent: "",
      limitOptions: [10, 20, 50, 100, 150, 200],
      fieldPagination: {},
      page: 1,
      limit: 10,
      loading: false,
      allIntegrations: [],
    };
  },
  computed: {
    getPredefinedApplications() {
      return this.integrations;
    },
    getGlobalFilterComponents() {
      let statsFilters = this.customDashboardData.allStatComponents.filter(
        (comp) => comp.integrationsSettings.radioFilter == "2"
      );
      let tableFilters = this.customDashboardData.allTableComponents.filter(
        (comp) => comp.integrationsSettings.radioFilter == "2"
      );
      let mergedFilters = statsFilters.concat(tableFilters);
      return mergedFilters;
    },
  },
  async mounted() {
    await this.getAllIntegrations();
    this.setSelectedEvents();
    await this.loadRequiredData();
    await this.checkAndLoadDependencies();
  },
  methods: {
    async getAllIntegrations() {
      let params = {
        limit: 10,
        page: 1,
      };
      const result = await postAPICall("GET", "integrations", params);
      this.allIntegrations = result.data;
    },
    async setAsset() {
      if (this.addStatsData.integrationsSettings.event_id) {
        let sanitizedEvent = this.addStatsData.integrationsSettings.event_id;
        let selectedIntegration = this.selectedIntegrationConnection(
          this.addStatsData.integrationsSettings.integration_id
        );
        let matchedApplication = selectedIntegration.application;
        let events = matchedApplication.events;
        let matchedEvent = events.find((event) => event._id === sanitizedEvent);
        this.addStatsData.integrationsSettings.event = matchedEvent;
        this.addStatsData.apply_date_filter = matchedEvent?.settings
          ?.isDateFilterIncluded
          ? true
          : false;
        await this.loadRequiredData(
          matchedEvent,
          matchedApplication,
          selectedIntegration._id
        );
      }
    },
    setSelectedEvents() {
      if (this.addStatsData?.integrationsSettings.integration_id) {
        let selectedIntegration = this.selectedIntegrationConnection(
          this.addStatsData.integrationsSettings.integration_id
        );
        if (selectedIntegration?.application) {
          let matchedApplication = selectedIntegration.application;
          if (matchedApplication?.events) {
            if (this.addStatsData.type.toLowerCase() === "stat") {
              this.selectedApplicationEvents = matchedApplication.events.filter(
                (event) =>
                  event.settings.supportType.toLowerCase() === "stat" ||
                  event.settings.supportType.toLowerCase() === "table"
              );
            } else {
              this.selectedApplicationEvents = matchedApplication.events.filter(
                (event) => event.settings.supportType.toLowerCase() === "chart"
              );
            }
          } else {
            this.selectedApplicationEvents = [];
          }
        }
      }
    },
    selectedIntegrationConnection(integration_id) {
      return this.getPredefinedApplications.find(
        (e) => e._id == integration_id
      );
    },
    async loadRequiredData(event, application, connectionId) {
      try {
        if (event?.settings.requiredFields.length) {
          let filterNoDependencyFields = event.settings.requiredFields.filter(
            (field) => field.dependencyField?.length === 0
          );
          await Promise.all(
            filterNoDependencyFields.map(async (ndpField) => {
              if (!this.fieldPagination[ndpField.key]) {
                this.$set(this.fieldPagination, ndpField.key, {
                  page: 1,
                  limit: 100,
                  loading: false,
                });
              }
              const pagination = this.fieldPagination[ndpField.key];
              pagination.loading = true;
              let payload = {
                appName: application.key,
                connectionId: connectionId,
                field: ndpField.key,
                pagination: {
                  page: pagination.page,
                  limit: pagination.limit,
                },
              };
              let response = await this.getIntegrationRequiredData(payload);
              // ndpField.values = response.data;
              // return response.data;
              if (response?.data) {
                // if (!ndpField.values) {
                this.$set(ndpField, "values", response.data);
                // }
                // ndpField.values.push(response.data);
                pagination.page += 1;
              }
              pagination.loading = false;
            })
          );
        }
      } catch (err) {
        return err;
      }
    },
    async loadDependentFields(selectedField) {
      try {
        let event = this.addStatsData.integrationsSettings.event;
        let dependencies = this.addStatsData.integrationsSettings.dependencies;
        let activeDependencies = [];
        event.settings.requiredFields.forEach((item) => {
          if (
            item.dependencyField &&
            item.dependencyField.includes(selectedField.key)
          ) {
            item.dependencyField.map((value) => {
              let isActiveDependentField = false;
              if (!dependencies[value]) {
                isActiveDependentField = false;
              } else {
                isActiveDependentField = true;
              }
              if (isActiveDependentField) {
                activeDependencies.push(item);
              }
            });
          }
        });
        let selectedIntegration = this.selectedIntegrationConnection(
          this.addStatsData.integrationsSettings.integration_id
        );
        if (activeDependencies.length) {
          await Promise.all(
            activeDependencies.map(async (field) => {
              let payload = {
                appName: selectedIntegration.application.key,
                connectionId: selectedIntegration._id,
                field: field.key,
                parameters: dependencies,
              };
              let response = await this.getIntegrationRequiredData(payload);
              field.values = response.data;
              return response.data;
            })
          );
        } else {
          let App = selectedIntegration.application;
          await this.loadRequiredData(event, App, selectedIntegration._id);
          return;
        }
        return;
      } catch (err) {
        return err;
      }
    },
    async getIntegrationRequiredData(payload) {
      try {
        let response = await postAPICall(
          "POST",
          "integrations/service/get-user-data",
          payload
        );
        return response;
      } catch (err) {
        return err;
      }
    },
    async checkAndLoadDependencies() {
      let dependencies = this.addStatsData.integrationsSettings.dependencies;
      let event = this.addStatsData.integrationsSettings.event;
      let keys = Object.keys(dependencies);
      await Promise.all(
        keys.map(async (key) => {
          let matchedOne = event.settings.requiredFields.find(
            (field) => field.key === key && !field.dependencyField.length
          );
          if (matchedOne) {
            await this.loadDependentFields(matchedOne);
          }
        })
      );
    },
    resetForm() {
      const defaultValues = {
        event_id: "",
        dependencies: {},
        selectedFields: [],
        groupBy: "",
        event: null,
      };

      Object.keys(defaultValues).forEach((key) => {
        this.$set(
          this.addStatsData.integrationsSettings,
          key,
          defaultValues[key]
        );
      });
    },

    resetFormAndUpdateEvents() {
      let connection = this.allIntegrations.find(
        (data) =>
          data._id == this.addStatsData.integrationsSettings.integration_id
      );
      if (connection) {
        let matched = this.integrations.find(
          (integration) => integration._id === connection._id
        );
        if (!matched) {
          this.integrations.push(connection);
        }
        this.resetForm();
        this.setSelectedEvents();
      } else {
        console.log("No Selected Connection found");
      }
    },
  },
};
</script>
